import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function NoAccess() {
  const { t } = useTranslation();
  return (
    <div className="fixed bottom-0 left-0 right-0 top-0">
      <div className="flex h-full w-full flex-col items-center justify-center gap-2 px-4">
        <span className="text-2xl">{t("noAccess.title")}</span>
        <p className="max-w-[100dvw] text-center">
          {t("noAccess.description")}
        </p>
        <Link
          to=".."
          className={`btn-lg w-[100px] bg-[#4CA6F8] text-white disabled:cursor-not-allowed disabled:bg-[#CCCCCC] disabled:text-[#7D7C7C]`}
        >
          {t("noAccess.back")}
        </Link>
      </div>
    </div>
  );
}

export default NoAccess;
